import { isSubscriptionPurchase } from '@grandvisionhq/fun-products';

/**
 * @deprecated
 */ const mapSolutionToDraftLineItem = ({ sku , state  })=>{
    const lineItemDraft = {
        sku,
        quantity: state.configurations.quantity,
        type: 'regular'
    };
    if (isSubscriptionPurchase(state.configurations.purchaseType)) {
        if (!state.configurations.subscriptionPurchaseConfigurations.deliveryInterval) {
            return;
        }
        lineItemDraft.typeDetails = {
            isSubscription: true,
            subscriptionDetails: {
                deliveryInterval: state.configurations.subscriptionPurchaseConfigurations.deliveryInterval
            }
        };
    }
    return lineItemDraft;
};

export { mapSolutionToDraftLineItem };
//# sourceMappingURL=map-solution-to-draft-line-item.js.map
